import {Component, Element, Event, EventEmitter, h, Listen, Prop, State} from '@stencil/core';
import {DateTime} from "luxon";
import {baseUri, endpoint_api, endpoint_portal, localStore, translate} from '../../../utils/utils';
import {
  aboStore,
  isOnlyPurchaseTunnelActive,
  shopConfigState,
  shopIntegrationState,
  themeState
} from "../../../utils/store";
import axios, {AxiosRequestConfig} from 'axios';

@Component({
  tag: 'ike-navbar',
  styleUrl: 'ike-navbar.scss',
  shadow: false,
})
export class IkeNavbar {
  @Prop() lite = false;
  @Prop() multiPeriodSwitch = false;

  @State() cart = null;
  @State() config = null;
  @State() menuOpen = false;
  @State() name: any;
  @State() queueInfos = null;
  @State() showPeriodsModal: boolean = false;
  @State() color = "#7974B4";

  @Event() getUtils: EventEmitter;

  /**
   * GTM trigger
   */
   @Event() ike_cart_delete: EventEmitter;

  @Element() private element: HTMLElement;

  private utils: any;
  private unsub = [];
  private intervalEmpty:any;
  private intervalQueue:any;

  @Listen('closeIkeModal')
  handleCloseIkeModal() {
    this.showPeriodsModal = false;
  }

  @Listen('ikeLogoutUser', { target: 'document' })
  handleLogoutUser(){
    this.logout();
  }

  componentWillLoad() {
    this.getUtils.emit(utils=>this.utils=utils);
    this.unsub.push(this.utils.cart(cart => this.cart = cart));
    this.unsub.push(this.utils.config(config => this.config = config));

    this.watchEmpty();
    this.watchQueue();
  }

  private watchEmpty(){
    let update = () => {
      let cartToWatch = this.cart;
if (!cartToWatch?.unbook && cartToWatch?.otherCarts?.length > 0) {
        cartToWatch = this.cart?.otherCarts[0];
      }
      if(cartToWatch.unbook) {
        const unbook = DateTime.fromISO(cartToWatch.unbook);
        const diff = unbook.diffNow(['minutes', 'seconds']).toObject();
        if(diff.seconds<0){
          aboStore.set('abo',{});
          const previousCart = {...cartToWatch};
          this.utils.http('post', '/cart/empty').then(data => {
            this.ike_cart_delete.emit({
              previousCart: previousCart,
              newCart: data.cart,
            });
            this.utils.store.set('cart', data.cart)
            this.utils.storage.set('uuid', '');
            this.utils.store.set('credits', '');
            localStore.setItem(this.utils.storage.get('uuid'), '');
            this.cart = data.cart
          });
          clearInterval(this.intervalEmpty);
        }
      }
    }
    this.intervalEmpty = setInterval(update, 1000);
    update();
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState == "visible") {
        clearInterval(this.intervalEmpty);
        this.intervalEmpty = setInterval(update, 1000);
        update();
      }
    })
  }

  private watchQueue(){
    if(this.config?.has_queue){
      this.intervalQueue = setInterval(()=>{
        let onSuccessPage = this.utils.route.path.includes('/success/');
        if(onSuccessPage){
          clearInterval(this.intervalQueue);
        } else {
          axios.get(endpoint_api+'/kueue-ping', {
            headers: {
              'kueue': sessionStorage.getItem('kueue') || '',
            },
            withCredentials: true,
          } as AxiosRequestConfig)
          .then(response => response.data)
          .then(ping => {
            if(ping.allowed_until <= 0){
              this.utils.http('get', '/cart?check=1').then(cart => {
                if(cart.waiting){
                  this.queueInfos = cart;
                  clearInterval(this.intervalQueue);
                }
              })
            }
          })
        }
      }, 15*1000);
    }
  }

  private toggleMenu() {
    this.element.querySelector('.hamburger').classList.toggle('active');
    this.element.querySelector('.content').classList.toggle('active');
    document.body.style.overflow = document.body.style.overflow === '' ? 'hidden' : '';
  }

  disconnectedCallback(){
    this.unsub.forEach(call=>call())
    clearInterval(this.intervalEmpty);
    clearInterval(this.intervalQueue);
  }

  private logout() {
    this.utils.logout();
  }

  private logo(){
    if (!this.multiPeriodSwitch && !shopIntegrationState.isEmbedded && !shopConfigState.advancedOptions.isPortalLogoHidden) {
      return <a itemprop="url" href={baseUri()} id="home-button">
        <ike-portal-logo theme={themeState.theme} accentColor={themeState.color}/>
      </a>
    }

    return <div onClick={() => this.showPeriodsModal = this.multiPeriodSwitch && !this.showPeriodsModal}>
      <ike-link class="title-3" url="/">
        <h1>{shopConfigState.layout?.language.title} {this.multiPeriodSwitch && <i class="icon-chevron-down title-4" />}</h1>
      </ike-link>
      <ike-modal visible={this.showPeriodsModal}>
        <div class="period-list-wrapper">
          <h1 class="title-2">{translate('Selectionnez une billetterie')}</h1>
          <span onClick={() => this.showPeriodsModal = !this.showPeriodsModal}><i class="icon-close" /></span>
        </div>
        {this.showPeriodsModal && <div class="default-shops-list">
          <ike-default-shops groupUuid={this.config?.period.orga_uuid} />
        </div>}
      </ike-modal>
    </div>;
  }

  render() {
    let cartCount = (this.cart?.normalTicketscount || 0) + (this.cart?.passescount || 0) + (this.cart?.giftcount || 0) + (this.cart?.donationCount || 0) + (this.cart?.productCount || 0)
    if (this.cart?.otherCarts) {
      this.cart?.otherCarts.map(otherCart => cartCount += (otherCart.normalTicketscount || 0) + (otherCart.passescount || 0) + (otherCart.giftcount || 0) + (otherCart.donationCount || 0) + (otherCart.productCount || 0))
    }
    this.utils.storeCartContent(cartCount);
    return (
      <header class={{"standalone" : isOnlyPurchaseTunnelActive()}}>
        <div class="responsive content">
          <div class="wrap actions-links">
            <div>
              <div class="link-display">
                <a onClick={() => {this.utils.goTo('/');this.toggleMenu();}} class="text-4">
                  <i class="icon icon-home"/>
                  {translate("Accueil")}
                </a>
              </div>
            </div>
            {shopIntegrationState.isEmbedded && <div>
              {this.utils.isUserLogged() ?
                <div>
                  <div slot="trigger" class="avatar" style={{'background-color': this.color, 'color': 'white'}}>
                    {this.name}
                  </div>
                  <div class="link-display">
                    <a onClick={() => {this.utils.goTo('/profile');this.toggleMenu();}}
                       class="text-4 dropdown__text">
                      <i class="icon icon-single-neutral-circle dropdown__icon"/>
                      {translate("Compte client")}
                    </a>
                  </div>
                  {this.config.abo_renew_available && !this.lite &&
                    <div class="link-display">
                      <a onClick={() => {
                        this.utils.goTo('/pass-renew');
                        this.toggleMenu();
                      }} class="text-4">
                        <i class="icon icon-abo"/>
                        {this.config?.passRenewText}
                      </a>
                    </div>
                  }
                  <div class="link-display">
                    <a onClick={() => {this.logout();this.toggleMenu();}} class="text-4 dropdown__text">
                      <i class="icon icon-logout dropdown__icon"/>
                      {translate("Deconnexion")}
                    </a>
                  </div>
                </div>
                :
                <div class="link-display">
                  <a onClick={() => {this.utils.goTo('/login');this.toggleMenu();}} class="text-4" data-cy={"goto-login"}>
                    <i class="icon icon-single-neutral-circle" aria-label={translate('Se connecter')}/>
                    {translate('Se connecter')}
                  </a>
                </div>
              }
            </div>}
            {!shopIntegrationState.isEmbedded &&
              <div class="link-display">
                <a href={`${baseUri()}/account`} class="text-4">
                  <i class="icon icon-single-neutral-circle" aria-label={translate('Compte client')}/>
                  {translate('Compte client')}
                </a>
              </div>}
            {this.config?.abo_available && !this.utils.isUserLogged() && !this.lite &&
              <div class="link-display">
                <a onClick={() => {this.utils.goTo('/pass-access');this.toggleMenu();}} class="text-4">
                  <i class="icon icon-abo"/>
                  {this.config?.passCodeText}
                </a>
              </div>
            }
            {this.cart?.currencies && !this.cart.furnished && this.cart?.currencies?.length > 1 && !this.lite &&
              <div>
                <i class="icon icon-accounting-coins-bill"/>
                <div class="currencies">
                  <p class="text-4">{translate('Devise')}</p>
                  <ike-dropdown placement="top" class="currencies">
                    <div slot="trigger" class="trigger button btn-cart">
                      {this.cart.currency.name} <i class="icon-chevron-down"/>
                    </div>
                    <div slot="content">
                      {this.cart.currencies.map(currency =>
                        <div class="dropdown__link" onClick={() => this.utils.handleSelectCurrency(currency.id, this.cart)}>
                          {currency.name}
                        </div>
                      )}
                    </div>
                  </ike-dropdown>
                </div>
              </div>
            }
            <div class="footer-line">
              <p class="text-4">powered by <a class="infomaniak" target={'_blank'} href={`${endpoint_portal}`}>infomaniak</a></p>
            </div>
          </div>
        </div>
        <div class="menu-container-desktop">
          <div class="responsive hamburger" onClick={() => this.toggleMenu()}>
            <span/><span/><span/>
          </div>
          {this.cart?.logo && <img class="logo" src="" alt=""/>}

          {this.logo()}

          <nav class="action-buttons desktop">
            {this.cart?.currencies && !this.cart.furnished && this.cart?.currencies?.length > 1 && !this.lite &&
              <ike-dropdown placement="bottom" class="currencies">
                <div slot="trigger" class="trigger button btn-cart">
                  {this.cart.currency.name} <i class="icon-chevron-down"/>
                </div>
                <div slot="content">
                  {this.cart.currencies.map(currency =>
                    <div class="dropdown__link" onClick={() => this.utils.handleSelectCurrency(currency.id, this.cart)}>
                      {currency.name}
                    </div>
                  )}
                </div>
              </ike-dropdown>
            }
            {(!isOnlyPurchaseTunnelActive() || cartCount > 0) && !this.lite &&
              <span>
                {(this.cart?.furnished || !this.cart?.otherCarts?.length) &&
                  <ike-link class="cart button btn-cart" url="/order">
                    <i class="icon-cart" aria-label={translate('Panier')}/>
                  {cartCount > 0 &&
                      <span class="cart-count">{cartCount}</span>
                    }
                  </ike-link>
                }
                {(!this.cart?.furnished && this.cart?.otherCarts?.length > 0) &&
                  <a class="relative" href={'/shop/' + this.cart?.otherCarts[0].shopRelativeUrl + '/order'}>
                    <i class="icon-cart" aria-label={translate('Panier')}/>
                    {cartCount > 0 &&
                      <span class="cart-count">{cartCount}</span>
                    }
                  </a>
                }
              </span>
            }
            <ike-avatar/>
            {this.config?.abo_available && !(this.cart?.customer && this.utils.storage.get('user_token')) && !this.lite &&
              <ike-link class="button primary btn-sm pass-access" url="/pass-access">
                <i class="icon-abo"/> {this.config?.passCodeText}
              </ike-link>
            }
          </nav>
          {(!isOnlyPurchaseTunnelActive() || cartCount > 0) && !this.lite && <ike-link class="cart responsive button btn-cart" url="/order">
            <i class="icon-cart" aria-label={translate('Panier')}/>{cartCount > 0 &&
            <span class="cart-count">{cartCount}</span>}
          </ike-link>}
        </div>
        <div class="navbar-responsive">
          <div class="wrap">
            {this.cart?.periods?.length > 1 && this.multiPeriodSwitch &&
            <div class="period-name">
              <button class="button title-3" onClick={() => this.showPeriodsModal = !this.showPeriodsModal}>
                {this.cart.period_name} <i class="icon-chevron-down title-4"/>
              </button>
              <ike-modal visible={this.showPeriodsModal}>
                <div class="period-list-wrapper">
                  <h1 class="title-2">{translate('Selectionnez une billetterie')}</h1>
                  <span onClick={() => this.showPeriodsModal = !this.showPeriodsModal}><i class="icon-close"/></span>
                </div>
                {this.showPeriodsModal && <div class="default-shops-list">
                  <ike-default-shops groupUuid={this.config?.period.orga_uuid} />
                </div>}
              </ike-modal>
            </div>
            }

            {this.cart?.periods?.length > 1 && !this.multiPeriodSwitch &&
              <div class="period-name">
                <h3 class="title-3">{this.cart.period_name}</h3>
              </div>
            }
            {(!isOnlyPurchaseTunnelActive() || (cartCount > 0)) && !this.lite && <ike-link class="cart button btn-cart" url="/order">
              <i class="icon-cart" aria-label={translate('Panier')}/>
              {cartCount > 0 && <span class="cart-count">{cartCount}</span>}
            </ike-link>}
            {this.cart?.customer && this.utils.storage.get('user_token') && <ike-avatar/>}
          </div>
        </div>

        <ike-modal visible={this.queueInfos} class="ike-queue-modal">
          <span class="icon-alarm-clock text-icon-title"/>
          <h2 class="title-1 margin-bottom-20">{translate('Temps expire')}</h2>
          <p class="margin-bottom-20">{translate("Les 15 minutes sont ecoulees. Vous pouvez toujours revenir dans la file d'attente si vous souhaitez effectuer une commande.")}</p>
          <button type="submit" class="button primary btn-lg" on-click={()=>this.utils.store.set('cart', this.queueInfos)}>
            {translate("Revenir dans la file d'attente")}
          </button>
        </ike-modal>
      </header>
    );
  }

}
